import { createContext } from "react";
import { GeneralContextInterface } from "../../Interfaces/ContextInterfaces/GeneralContext";

const GeneralContext = createContext<GeneralContextInterface | undefined>(undefined);

export default GeneralContext